import { create, update, updatePass } from "../../api";
import config from "../../assets/config";
import { authStore, headerDisplayStore } from "../../stores/General";
import { getClient } from "./client";
import { logout } from "./logout";


export const createAuthUser = async (userInfo) => {
  create("user", userInfo)
    .then(async (response) => {
      if (response?.status === "ok") {
        await authStore.user.set(response.object);
        authStore.isAuthenticated.set(true);
        // headerDisplayStore.ShowNotification({
        //   title: "Success",
        //   subtitle: "User logged in successfully",
        // });
      } else {
        headerDisplayStore.ShowError({
          title: "Error",
          subtitle: response?.error,
        });
      }
    })
    .catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
        subtitle: error?.message,
      });
    });
}

export const updatePassword = async (details) => {
  const client = await getClient();
  const usd = await client.getUser();

  if (details.newPass !== details.confirmNewPass) {
    headerDisplayStore.ShowError({
      title: "Error",
      subtitle: "New password and confirm password mismatch",
    });

  }

  const { auth0_mgt_token } = config;

  let body = {
    user_id: usd.sub,
    connection: "Username-Password-Authentication",
    password: details.newPass,
    token: auth0_mgt_token,
  };

  updatePass("user", body)
    .then((response) => {
      if (response?.status === "ok") {
        authStore.user.set(response.object);
        authStore.isAuthenticated.set(true);
        headerDisplayStore.ShowNotification({
          title: "Success",
          subtitle: "Password updated successfully",
        });
        logout({
          returnTo: window.location.origin + "/login",
        });
      } else {
        headerDisplayStore.ShowError({
          title: "Error",
          subtitle: response?.error,
        });
      }
    })
    .catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
        subtitle: error?.message,
      });
    });
};

export const updateAuthUser = async (details) => {
  update("user", details)
    .then((response) => {
      if (response?.status === "ok") {
        headerDisplayStore.ShowNotification({
          title: "Success",
          subtitle: "User info updated successfully",
        });
        checkAuth()
      } else {
        headerDisplayStore.ShowError({
          title: "Error",
          subtitle: response?.error,
        });
      }
    })
    .catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
        subtitle: error?.message,
      });
    });
};
function checkAuth() {
  throw new Error("Function not implemented.");
}

